import { Component, EventEmitter, Input,  Output } from '@angular/core';
import {  Router } from '@angular/router';
import { CommonService } from '../../../../services/common';
import { SalesService } from '../../sales.service';
import { FormGroup } from '@angular/forms';
import { IconList } from '../../../../../iconlist';
import { environment } from '../../../../../environments/environment';
declare const $: any;

@Component({
  selector: 'app-payment-plan-list',
  templateUrl: './payment-plan-list.component.html',
  styleUrl: './payment-plan-list.component.scss'
})
export class PaymentPlanListComponent {

  @Input() paymentPlanListData: any;
  @Output() changeModelStatus = new EventEmitter<any>();
  context: any
  paymentForm!: FormGroup
  dropdownMenu: any;
  exportSelectedType: string = '';
  ActionList: boolean = false;
  projectId: any = null;
  siteId: any = null;
  frameworkComponents: any;
  columnDefs!: any[];
  defaultColDef: any;
  filterTerm!: any;
  clientfileName = '';
  showExport: boolean = false;
  isDropdownOpen = false;
  fileName = '';
  excelStyles: any[] = [];
  gridOptions: any;
  showaddUpdateModal: boolean = false
  currentSelectedRecourd: any;
  exportButton: string = environment.assetsImagePath + IconList.exportButtonIcon
  addButton: string = environment.assetsImagePath + IconList.AddbuttonIcon
editIcon = environment.assetsImagePath + IconList.EditIconDropdown;
selectedExportData:any[]=[];
  /**
 * Export data Common Module through ExportList Component
 */
  exportColumns: any[] = [
    { cellClass: "cellCenter", headerCheckboxSelection: true, checkboxSelection: true, maxWidth: 65 },
    { headerName: "Name", field: "name" },

  ];
  columnKeys: any[] = ['name'];
  keysToSearch: string[] = ['name']
  gridApi: any;
  editId: any;
  isClickable: any;

  constructor(public commonService: CommonService, private saleservice: SalesService, private router: Router) { this.context = this }

  ngOnInit() {
    this.saleservice.showpaymentAddUpdateData = false
    this.setSiteId();
    this.agGridHeaderList()
  }

  /**
   * Ag grid Header List
   */
  agGridHeaderList() {

    this.columnDefs = [
      {
        field: 'selection', columnType: 'checkbox'
      },
      { header: "Name", field: "name", columnType: 'text' },
      {
        header: "Actions", field: "options", columnType: 'dropdown', options: [
          { label: 'Edit', value: 'edit', icon:  this.editIcon}
        ]
      },
    ];
  }

  /**
   * updating data on behalf of siteId
   */
  setSiteId() {
    this.siteId = this.commonService.localStorageSiteId;
  }

  /**
   * populating data of payment on behalf of project changed
   */
  getDataOnProjectLoad() {
    this.commonService.selectedProjects$.subscribe(project => {
      if (project) {
        this.projectId = project.id;

      }
      else {//else rowData will empty

      }
      if (this.gridApi) {
        this.gridApi.setRowData(this.paymentPlanListData);
      }
    });
  }

  // Set Mobile View Control Update
  /**
   *
   * @param data enbale the payment detail to be edit
   */
  Editmodal(data: any) {
    this.editId = data.id;
    // Data Value Set
    this.paymentForm.controls['namr'].setValue(data.name);

  }

  /**
    *
    * @param {any} paymentId Redirecting from payment action trigerred option using paymentId
    */
  dropdownActonMenu(paymentId: any) {
    this.dropdownMenu = document.getElementById("actionMenuContent" + paymentId);
    this.dropdownMenu?.classList.toggle("dropdownActionMenu");
    this.ActionList = !this.ActionList;
  }

  //Showing modal on click of add payment button
  changeAddUpdateModalState(currentRecord?: any) {
    this.changeModelStatus.emit({
      "showaddUpdateModal": true,
      "currentSelectedRecord": currentRecord?.currentRow
    });
  }

  changeAddUpdateModalStateMobile(currentRecord?: any){
    this.changeModelStatus.emit({
      "showaddUpdateModal": true,
      "currentSelectedRecord": currentRecord
    });
  }
  //Showing modal on click of add payment button
  EditOptionClicked() {
    this.changeModelStatus.emit({
      "showaddUpdateModal": true
    })
  }


  onSelectedRowsChange(selectedRows: any) {
    this.selectedExportData = [];
      let exportedObject :any[] = [];

  selectedRows.forEach((row:any) => {
    let customerDetailObject = row;
    if (customerDetailObject) {
      let rowData = {
        "Name" : customerDetailObject.name
      };
      exportedObject.push(rowData);
    }
  });

  this.selectedExportData = exportedObject;
    }

  deleteData(id: any) {
    this.saleservice.deletePaymentPlanData(id).subscribe((res: any) => {
      this.saleservice.getPaymentPlanObserval().subscribe((data: any) => {
        if (data) {
          this.paymentPlanListData.push(data);
          this.gridApi.setRowData(this.paymentPlanListData);
        }
      })
    })
  }

  //to hide the export common component when needed
  hideExport() {
    this.showExport = false;
  }

  toggleDropdown() {
    //$("#bankName").attr('disabled', 'disabled');
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  /**
  *
  * @param type toggle the export button and redirect the open common export-component
  */
  toggleExport(type: string) {
    this.exportSelectedType = type;
    this.showExport = !this.showExport;
  }

  /**
   *
   * @param data Set Data Mobile View Export Excel/PDF
   */
  exportValues(data: any) {
    if (data) {
      this.paymentForm.controls['sourceName'].setValue(data[0].sourceName);
      this.showExport = false;
    }
  }

  getPaymentDetails() {
    this.saleservice.getPaymentObserval().subscribe(data => {
      if (data) {
        this.paymentPlanListData.push(data);
        this.gridApi.setRowData(this.paymentPlanListData);
      }
    })
  }

  Close() {

  }

}

